(() => {
  const host = document.querySelector('[data-plc-chatbot]');
  if (!host || window.Shopify?.designMode) return;
  const id = (host.dataset.appId || '').trim();
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id)) return;
  const selector = `.elfsight-app-${id}`;
  if ([...document.querySelectorAll(selector)].some(node => node !== host)) { host.remove(); return; }
  host.classList.add(`elfsight-app-${id}`);
  host.setAttribute('data-elfsight-app-lazy', '');
  const exists = [...document.scripts].some(script => {
    try { const url = new URL(script.src); return /(^|\.)elfsight(cdn)?\.com$/.test(url.hostname) && url.pathname.endsWith('/platform.js'); } catch { return false; }
  });
  if (!exists && !window.eapps) {
    const script = document.createElement('script');
    script.src = 'https://elfsightcdn.com/platform.js';
    script.async = true;
    script.id = 'PLCElfsightPlatform';
    host.after(script);
  }
})();
